import { Box, useMediaQuery } from '@mui/material'
import { isEqual } from 'lodash-es'
import React, { useEffect, useState } from 'react'

import { BREAKPOINT_MIN_MD } from '../../../../Theme/stylesUtil'
import { JudgeProfile } from './JudgeProfileComponents/JudgeProfile'
import { SearchJudgesContainer } from './SearchJudgesContainer'

const boxStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}
const modalBoxStyles = {
  ...boxStyles,
  maxHeight: 270,
  overflow: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}

const JudgesForm = ({ isModal = false, judges, contestId, ownerId, setValue, action, contest }) => {
  const [search, setSearch] = useState('')
  const [selectedJudge, setSelectedJudge] = useState(judges[0]?.id)
  const judgeIndex = judges.findIndex((item) => item.id === selectedJudge)
  const isEdit = action === 'edit'
  const showJudgeProfile = !isModal && isEdit
  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)
  useEffect(() => {
    if (judgeIndex < 0) setSelectedJudge(judges[0]?.id)
  }, [judgeIndex, judges, selectedJudge])

  return (
    <Box
      display="flex"
      flexDirection={isBiggerThanMDScreen ? 'row' : 'column'}
      gap={5}
    >
      <SearchJudgesContainer
        roundLimits={contest?.round_limits}
        styles={!isModal ? boxStyles : modalBoxStyles}
        search={search}
        setSearch={setSearch}
        judges={judges}
        selectedJudge={isEdit ? selectedJudge : 0}
        setSelectedJudge={setSelectedJudge}
        showEmpty={search}
        contestId={contestId}
        ownerId={ownerId}
        isModal={isModal}
        setValue={setValue}
        action={action}
      />
      {showJudgeProfile && (
        <JudgeProfile
          judgeIndex={judgeIndex < 0 ? 0 : judgeIndex}
          contestId={contestId}
          contest={contest}
        />
      )}
    </Box>
  )
}

const equalProps = (prevProps, nextProps) => isEqual(prevProps, nextProps)

export default React.memo(JudgesForm, equalProps)
